import BaseService from "../../services/BaseService";
import ReportService from "../../services/ReportService";

export default {
    state: {
        balance_sheet: [],
    },
    getters: {
        balanceSheet: state => {
            return state.balance_sheet;
        },
    },
    mutations: {
        SET_BALANCE_SHEET(state, balance_sheet) {
            state.balance_sheet = balance_sheet;
        },
    },
    actions: {
        async balanceSheet( { commit }, filter) {
            if (filter) {
                let result = await ReportService.balanceSheet(filter);
                if (result.status === BaseService.STATUS_200) {
                    commit('SET_BALANCE_SHEET', result.data);
                }
            }
        },
    },
}